import { useEffect, useMemo, useState } from "react"

const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
const audioCache = new Map()

// Returns play object twice, once when audiobuffer is not yet loaded
//  then once again when it is loaded
function useSoundEffect(audio, volume = 1) {
  const [audioBuffer, setAudioBuffer] = useState(undefined)
  const [isPlaying, setPlaying] = useState(false)

  const gainNode = audioCtx.createGain()
  gainNode.gain.value = volume
  gainNode.connect(audioCtx.destination)

  // Load AudioBuffer only once
  useEffect(() => {
    if (audioCache.has(audio)) {
      setAudioBuffer(audioCache.get(audio))
    } else {
      fetch(audio)
        .then(f => f.arrayBuffer())
        .then(ab => audioCtx.decodeAudioData(ab))
        .then(buffer => {
          setAudioBuffer(buffer)
          audioCache.set(audio, buffer)
        })
    }
  }, [])

  return useMemo(() => ({ 
    play: (delay = 0) => {
      // New AudioBufferSourceNode for every play
      let source = audioCtx.createBufferSource()

      source.buffer = audioBuffer
      source.connect(gainNode)

      source.onended = () => setPlaying(false)

      source.start(delay / 1000)
      setTimeout(() => setPlaying(true), delay)
    },
    isPlaying
  }), [audioBuffer, isPlaying])
}

export default useSoundEffect